module.exports = __webpack_public_path__ + "static/main-logo-8b68d86aea7cc10a2cfb9d74d73e8483.svg";